import logo from "../assets/byteplay.png";
import logonew from "../assets/byteplay2.png";
import hero2 from "../assets/hero2.avif";
import hero from "../assets/hero.png";
import postgif from "../assets/posts/postgif.gif";
import post1gif from "../assets/posts/post1gif.gif";
import CtaImage from "../assets/posts/CtaImage.gif";
import post1 from "../assets/posts/post1.png";
import post2 from "../assets/posts/post2.png";
import post3 from "../assets/posts/post3.png";
import postprofileImage from "../assets/posts/profileimage.avif";
import davebg from "../assets/davidbg.png";
import dav from "../assets/dav.jpg";
import dave from "../assets/dave.jpg";
import david from "../assets/david.jpg";
const samplePostImage = "/images/sample.jpg";
const userImage = "/images/user.png";


const images = {
    logo,logonew, hero, hero2, postgif, post1gif,CtaImage, post1, post2, post3,
    postprofileImage,davebg,dav,dave,david,samplePostImage,userImage,
   
}

export default images;